export * from './iconsCheck.component';
export * from './iconsCross.component';
export * from './iconSuccess.component';
export * from './iconError.component';
export * from './iconWarning.component';
export * from './iconMastercard.component';
export * from './iconMir.component';
export * from './iconVisa.component';
